export default __webpack_public_path__ + "static/media/humaniq-logo.a05e5b5b.svg";